/* HAB Collections — shared UI behaviour.
   Deliberately dependency-free and idempotent: it can be included by
   several sections on the same page without double-binding. */
(function () {
  if (window.__habUI) return;
  window.__habUI = true;

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = $('[data-hab-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast'; t.setAttribute('data-hab-toast', '');
      (document.querySelector('.hab') || document.body).appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(t._x);
    t._x = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }
  window.habToast = toast;

  /* ---------- panels (menu / search / filters / size chart) ---------- */
  function closeAll() {
    $$('[data-hab-panel]').forEach(function (p) { p.classList.remove('on'); });
    var s = $('[data-hab-scrim]'); if (s) s.classList.remove('on');
    document.body.style.overflow = '';
    $$('[data-hab-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function openPanel(name, btn) {
    var p = $('[data-hab-panel="' + name + '"]');
    if (!p) return;
    p.classList.add('on');
    var s = $('[data-hab-scrim]'); if (s) s.classList.add('on');
    document.body.style.overflow = 'hidden';
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (name === 'search') { var i = p.querySelector('input'); if (i) setTimeout(function () { i.focus(); }, 120); }
    if (name === 'filters') $$('.only-m', p).forEach(function (e) { e.style.display = 'block'; });
    if (name === 'wishlist') renderWishDrawer();
  }
  window.habCloseAll = closeAll;

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-hab-open]');
    if (open) { e.preventDefault(); openPanel(open.getAttribute('data-hab-open'), open); return; }
    if (e.target.closest('[data-hab-close]') || e.target.closest('[data-hab-scrim]')) { closeAll(); return; }

    var fg = e.target.closest('[data-fg]');
    if (fg) {
      var grp = fg.parentElement;
      grp.classList.toggle('closed');
      var fi = fg.querySelector('i');
      if (fi) fi.textContent = grp.classList.contains('closed') ? '+' : '−';
      return;
    }

    var acc = e.target.closest('.acc-item > button');
    if (acc) {
      var item = acc.parentElement;
      item.classList.toggle('on');
      var i = acc.querySelector('i');
      if (i) i.textContent = item.classList.contains('on') ? '−' : '+';
      return;
    }

    var hero = e.target.closest('[data-hab-slide]');
    if (hero) { goSlide(parseInt(hero.getAttribute('data-hab-slide'), 10), true); return; }

    var heroPrev = e.target.closest('[data-hab-hero-prev]');
    if (heroPrev) { goSlide(hi - 1, true); return; }

    var heroNext = e.target.closest('[data-hab-hero-next]');
    if (heroNext) { goSlide(hi + 1, true); return; }

    var heroPause = e.target.closest('[data-hab-hero-pause]');
    if (heroPause) { setHeroPaused(!heroPaused); return; }

    var wish = e.target.closest('[data-hab-wish]');
    if (wish) { e.preventDefault(); toggleWish(wish); return; }

    var wishRemove = e.target.closest('[data-hab-wish-remove]');
    if (wishRemove) { e.preventDefault(); removeWish(wishRemove.getAttribute('data-hab-wish-remove')); return; }

    var wishAddAll = e.target.closest('[data-hab-wish-addall]');
    if (wishAddAll) { e.preventDefault(); addSelectedToCart(); return; }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- header shadow ---------- */
  var hdr = $('[data-hab-header]');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('scrolled', window.scrollY > 10); };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- announcement rotator ---------- */
  var anno = $('[data-hab-anno]');
  if (anno) {
    var items = $$('.anno-item', anno), ai = 0, at;
    if (items.length > 1) {
      var ms = (parseFloat(anno.getAttribute('data-interval')) || 4) * 1000;
      var go = function (n) {
        items[ai].classList.remove('on');
        ai = (n + items.length) % items.length;
        items[ai].classList.add('on');
      };
      var start = function () { at = setInterval(function () { go(ai + 1); }, ms); };
      var nudge = function (d) { clearInterval(at); go(ai + d); start(); };
      var pv = $('[data-hab-anno-prev]'), nx = $('[data-hab-anno-next]');
      if (pv) pv.addEventListener('click', function () { nudge(-1); });
      if (nx) nx.addEventListener('click', function () { nudge(1); });
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    }
  }

  /* ---------- hero slideshow ---------- */
  var hero = $('[data-hab-hero]'), slides = [], dots = [], hi = 0, ht;
  var heroReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heroPaused = heroReducedMotion;
  var heroPauseBtn = $('[data-hab-hero-pause]');
  function goSlide(i, manual) {
    if (!slides.length) return;
    hi = (i + slides.length) % slides.length;
    slides.forEach(function (s, j) { s.classList.toggle('on', j === hi); });
    dots.forEach(function (d, j) { d.classList.toggle('on', j === hi); });
    if (manual) { clearInterval(ht); if (!heroPaused) startHero(); }
  }
  function startHero() {
    if (!hero || slides.length < 2 || heroReducedMotion) return;
    var ms = (parseFloat(hero.getAttribute('data-interval')) || 6) * 1000;
    ht = setInterval(function () { goSlide(hi + 1); }, ms);
  }
  function setHeroPaused(state) {
    heroPaused = state;
    clearInterval(ht);
    if (!heroPaused) startHero();
    if (hero) hero.classList.toggle('paused', heroPaused);
    if (heroPauseBtn) {
      heroPauseBtn.classList.toggle('paused', heroPaused);
      heroPauseBtn.setAttribute('aria-pressed', heroPaused ? 'true' : 'false');
      heroPauseBtn.setAttribute('aria-label', heroPaused ? 'Play slideshow' : 'Pause slideshow');
    }
  }
  if (hero) {
    slides = $$('.hero-slide', hero);
    dots = $$('[data-hab-slide]', hero);
    if (heroPauseBtn) {
      hero.classList.toggle('paused', heroPaused);
      heroPauseBtn.classList.toggle('paused', heroPaused);
      heroPauseBtn.setAttribute('aria-pressed', heroPaused ? 'true' : 'false');
      heroPauseBtn.setAttribute('aria-label', heroPaused ? 'Play slideshow' : 'Pause slideshow');
    }
    startHero();
  }

  /* ---------- wishlist (local to this browser) ---------- */
  function wishSet() {
    try { return new Set(JSON.parse(localStorage.getItem('hab:wish') || '[]')); }
    catch (e) { return new Set(); }
  }
  function wishSave(s) {
    try { localStorage.setItem('hab:wish', JSON.stringify(Array.from(s))); } catch (e) {}
  }
  function paintWish() {
    var s = wishSet();
    $$('[data-hab-wish]').forEach(function (b) {
      b.classList.toggle('on', s.has(b.getAttribute('data-hab-wish')));
    });
    var c = $('[data-hab-wish-count]');
    if (c) { c.textContent = s.size; c.style.display = s.size ? 'grid' : 'none'; }
  }
  function toggleWish(btn) {
    var h = btn.getAttribute('data-hab-wish'), s = wishSet();
    if (s.has(h)) { s.delete(h); toast('Removed from wishlist'); }
    else { s.add(h); toast('Saved to wishlist'); }
    wishSave(s); paintWish();
  }
  paintWish();

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatMoney(cents, currency) {
    try { return new Intl.NumberFormat(navigator.language, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function removeWish(handle) {
    var s = wishSet();
    s.delete(handle);
    wishSave(s); paintWish(); renderWishDrawer();
  }
  function pickVariant(product) {
    var variants = product.variants || [];
    var v = null;
    for (var i = 0; i < variants.length; i++) { if (variants[i].available) { v = variants[i]; break; } }
    if (!v) return null;
    var sizeIdx = -1;
    (product.options || []).forEach(function (name, i) { if (sizeIdx === -1 && /size/i.test(name)) sizeIdx = i; });
    var label = sizeIdx > -1 ? (v['option' + (sizeIdx + 1)] || '') : (v.title !== 'Default Title' ? v.title : '');
    return { id: v.id, label: label };
  }
  function updateWishFooter() {
    var footer = $('[data-hab-wish-footer]'), btn = $('[data-hab-wish-addall]');
    if (!footer || !btn) return;
    var any = !!$('[data-hab-wish-check]');
    var checked = $$('[data-hab-wish-check]:checked:not([disabled])');
    footer.style.display = any ? 'block' : 'none';
    btn.disabled = checked.length === 0;
    btn.textContent = checked.length > 1 ? 'Add to Cart (' + checked.length + ')' : 'Add to Cart';
  }
  function updateCartBadge() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var el = $('[data-hab-cart-count]');
      if (el) { el.textContent = c.item_count; el.style.display = c.item_count ? 'grid' : 'none'; }
    }).catch(function () {});
  }
  function addSelectedToCart() {
    var btn = $('[data-hab-wish-addall]');
    var boxes = $$('[data-hab-wish-check]:checked:not([disabled])');
    if (!boxes.length) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    /* Add one at a time — Shopify's /cart/add.js with an `items` array is
       all-or-nothing, so a single stock-limited variant would otherwise
       block every other item in the batch. */
    Promise.all(boxes.map(function (b) {
      var id = parseInt(b.getAttribute('data-variant-id'), 10);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function (r) { return { ok: r.ok }; }).catch(function () { return { ok: false }; });
    })).then(function (results) {
      var ok = results.filter(function (r) { return r.ok; }).length;
      if (ok === results.length) toast(ok > 1 ? 'Added ' + ok + ' items to cart' : 'Added to cart');
      else if (ok > 0) toast('Added ' + ok + ' of ' + results.length + ' — the rest are out of stock or already at cart limit');
      else toast('Could not add to cart — please check stock');
      if (ok > 0) updateCartBadge();
    }).then(function () { updateWishFooter(); });
  }
  function renderWishDrawer() {
    var panel = $('[data-hab-panel="wishlist"]'), list = $('[data-hab-wish-list]');
    if (!list) return;
    var handles = Array.from(wishSet());
    var currency = (panel && panel.getAttribute('data-currency')) || 'USD';
    var count = $('[data-hab-wish-drawer-count]');
    if (count) { count.textContent = handles.length; count.style.display = handles.length ? 'flex' : 'none'; }
    if (!handles.length) {
      list.innerHTML = '<p class="wish-empty">Nothing saved yet. Tap the heart on any product to add it here.</p>';
      updateWishFooter();
      return;
    }
    list.innerHTML = '<p class="wish-empty">Loading…</p>';
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      products.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var url = escapeHtml(p.url), title = escapeHtml(p.title), handle = escapeHtml(handles[i]);
        var variant = pickVariant(p);
        var sold = !variant;
        html += '<div class="wish-item' + (sold ? ' sold' : '') + '">' +
          '<input type="checkbox" class="wish-item-check" data-hab-wish-check' +
            (variant ? ' data-variant-id="' + variant.id + '"' : '') +
            (sold ? ' disabled' : ' checked') + ' aria-label="Select ' + title + '">' +
          '<a class="wish-item-media" href="' + url + '">' +
            (img ? '<img src="' + escapeHtml(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="wish-item-body">' +
            '<a class="wish-item-title" href="' + url + '">' + title + '</a>' +
            (sold
              ? '<span class="wish-item-sold-label">Sold out</span>'
              : '<span class="wish-item-price">' + formatMoney(p.price, currency) + '</span>' +
                (variant.label ? '<span class="wish-item-variant">Size: ' + escapeHtml(variant.label) + '</span>' : '')) +
          '</div>' +
          '<button type="button" class="wish-item-remove" data-hab-wish-remove="' + handle + '" aria-label="Remove from wishlist">×</button>' +
        '</div>';
      });
      list.innerHTML = html || '<p class="wish-empty">Nothing saved yet. Tap the heart on any product to add it here.</p>';
      updateWishFooter();
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.hasAttribute('data-hab-wish-check')) updateWishFooter();
  });

  /* ---------- PLP filters: auto-submit on change ---------- */
  var ff = document.getElementById('HabFilterForm');
  if (ff) {
    ff.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-hab-autosubmit')) {
        if (window.innerWidth > 1100) ff.submit();
        else {
          var lbl = e.target.closest('.fcolor, .fsize');
          if (lbl) lbl.classList.toggle('on', e.target.checked);
        }
      }
    });
  }
})();